const initModal = () => {
  const openers = Array.from(document.querySelectorAll('[data-modal-open]'))
  const modals = Array.from(document.querySelectorAll('[data-modal][data-modal-id]'))

  if (!openers.length && !modals.length) return

  const normalizeHash = (hash) => {
    if (!hash) return ''
    return hash.replace('#', '').replace(/\/+$/, '')
  }

  const getModalByHash = (hash) => {
    const id = normalizeHash(hash)
    if (!id) return null
    return (
      document.querySelector(`[data-modal][data-modal-id="${id}"]`) ||
      document.querySelector(`#${id}[data-modal]`)
    )
  }

  const open = (modal, hash, skipHash = false) => {
    if (!modal) return
    modal.removeAttribute('hidden')
    document.body.classList.add('is-modal-open')
    if (!skipHash && hash && window.location.hash !== hash) {
      history.pushState(null, '', hash)
    }
  }

  const close = (modal, hash, skipHash = false) => {
    if (!modal) return
    modal.setAttribute('hidden', '')
    if (!document.querySelector('[data-modal]:not([hidden])')) {
      document.body.classList.remove('is-modal-open')
    }
    if (!skipHash && hash && window.location.hash === hash) {
      history.pushState(null, '', window.location.pathname + window.location.search)
    }
  }

  const bindModal = (modal) => {
    const closeButtons = Array.from(modal.querySelectorAll('[data-modal-close]'))
    const form = modal.querySelector('[data-modal-form]')
    const hash = `#${modal.getAttribute('data-modal-id')}`

    closeButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault()
        close(modal, hash)
      })
    })

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        close(modal, hash)
      }
    })

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault()
      })
    }
  }

  modals.forEach(bindModal)

  openers.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault()
      const hash = button.getAttribute('data-modal-open') || button.getAttribute('href')
      const modal = getModalByHash(hash)
      open(modal, hash)
    })
  })

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]')
    if (!link) return
    const hash = link.getAttribute('href')
    const modal = getModalByHash(hash)
    if (!modal) return
    event.preventDefault()
    open(modal, hash)
  })

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return
    const activeModal = document.querySelector('[data-modal]:not([hidden])')
    if (!activeModal) return
    close(activeModal, `#${activeModal.getAttribute('data-modal-id')}`)
  })

  const initialModal = getModalByHash(window.location.hash)
  if (initialModal) {
    open(initialModal, window.location.hash, true)
  }

  window.addEventListener('hashchange', () => {
    const targetModal = getModalByHash(window.location.hash)
    const activeModal = document.querySelector('[data-modal]:not([hidden])')

    if (targetModal) {
      if (activeModal && activeModal !== targetModal) {
        close(activeModal, `#${activeModal.getAttribute('data-modal-id')}`, true)
      }
      if (targetModal.hasAttribute('hidden')) {
        open(targetModal, window.location.hash, true)
      }
      return
    }

    if (activeModal) {
      close(activeModal, `#${activeModal.getAttribute('data-modal-id')}`, true)
    }
  })
}

export default initModal



// WEBPACK FOOTER //
// ./resources/assets/js/components/modal.js